/*ěščřžýáíéúů*/

jQuery(document).ready(function ($) {
    $('body').on('click', '.js-open-modal', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $($(this).attr('href')).modal();
    });
});
